import type { AreaRoutes } from "@/app/routes/hr/areaRoutes";
import { RequireCapability } from "@/app/session/RequireCapability";

/* Attendance and requests: the month grid, review, imports, the request inbox and one's own month. */
export const attendanceRoutes: AreaRoutes = {
  people: [
    {
      path: "attendance",
      lazy: async () => ({
        Component: (await import("@/features/attendance/routes/AttendanceLayout")).default,
      }),
      children: [
        {
          index: true,
          lazy: async () => ({
            Component: (await import("@/features/attendance/routes/AttendanceGridTab")).default,
          }),
        },
        {
          path: "review",
          lazy: async () => ({
            Component: (await import("@/features/attendance/routes/AttendanceReviewTab")).default,
          }),
        },
        {
          // Imports change days: HR managers only, as the server says.
          element: <RequireCapability permission="hr.manage" />,
          children: [
            {
              path: "imports",
              lazy: async () => ({
                Component: (await import("@/features/attendance/routes/AttendanceImportsTab"))
                  .default,
              }),
            },
          ],
        },
        {
          path: "settings",
          lazy: async () => ({
            Component: (await import("@/features/attendance/routes/AttendanceSettingsTab")).default,
          }),
        },
      ],
    },
  ],
  employee: [
    {
      path: "attendance",
      lazy: async () => ({
        Component: (await import("@/features/attendance/routes/EmployeeAttendanceTab")).default,
      }),
    },
  ],
  me: [
    {
      path: "attendance",
      lazy: async () => ({
        Component: (await import("@/features/attendance/routes/MyAttendanceTab")).default,
      }),
    },
  ],
  top: [
    {
      path: "requests",
      lazy: async () => ({
        Component: (await import("@/features/requests/routes/RequestsLayout")).default,
      }),
      children: [
        {
          index: true,
          lazy: async () => ({
            Component: (await import("@/features/requests/routes/InboxPage")).default,
          }),
        },
        {
          path: "delegations",
          lazy: async () => ({
            Component: (await import("@/features/requests/routes/DelegationsPage")).default,
          }),
        },
      ],
    },
  ],
};
